import React, { useMemo } from "react";
import { TextField, MenuItem } from "@mui/material";

const generarEjercicios = (rango = 2) => {
    const añoActual = new Date().getFullYear();

    return Array.from({ length: rango * 2 + 1 }, (_, i) => {
        const año = añoActual - rango + i;
        return {
            value: año.toString(),
            label: año.toString()
        };
    });
};

const SelectEjercicio = ({
    value,
    onChange,
    rango = 2,
    label = "Ejercicio",
    sx = { width: 150 },
    size = "small",
    fullWidth = false,
    className = ""
}) => {
    const ejercicios = useMemo(() => generarEjercicios(rango), [rango]);

    return (
        <TextField
            className={className}
            fullWidth={fullWidth}
            size={size}
            label={label}
            select
            value={value}
            onChange={e => onChange(e.target.value)}
            sx={sx}
        >
            {ejercicios.map(ej => (
                <MenuItem key={ej.value} value={ej.value}>
                    {ej.label}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default SelectEjercicio;
